"use client"

import { useSize } from "@/lib/hooks/useSize";
import { useEffect, useRef } from "react";
import "./globals.css";
import { EventType } from "@vertical-insure/shared";
import DatadogInit from "@/lib/datadog-init";

export default function RootLayout({
  children,
}: {
  children: React.ReactNode
}) {
  const resizeTarget = useRef(null);
  const size = useSize(resizeTarget);

  useEffect(() => {
    if (size?.height && size?.width) {
      // nosemgrep: wildcard-postmessage-configuration
      window?.parent?.postMessage({
        eventType: EventType.resize,
        height: size?.height, 
        width: size?.width
      }, '*');
    }
  }, [size]);

  return (
    <html lang="en" ref={resizeTarget}>
      <body className="w-full">
        <DatadogInit />
        {children}
      </body>
    </html>
  )
}